var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:_vm.highlightPast && !_vm.format.future && 'text-red-3'},[_vm._v(_vm._s(_vm.format.text))])
}
var staticRenderFns = []

export { render, staticRenderFns }